import React, {Component} from 'react';
const { connect } = require('react-redux');
import MasonryLayout from 'react-masonry-layout';

import Footer from '../../components/Footer';
import HeaderMemberGuestbook from 'components/member/HeaderMemberGuestbook';
import GuestbookItem from 'components/guestbook/GuestbookItem';
import DisableMyGuestbook from 'components/guestbook/DisableMyGuestbook';

import {t} from 'l10n';

import 'sass/guestbook.scss';

import {getMemberGuestbook} from 'reducers/memberGuestbook';

class MemberGuestbook extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {
        this.props.getMemberGuestbook();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.guestbookMessages.totalCount != this.props.guestbookMessages.totalCount) {
            this.masonryLayout.getBricksInstance().pack();
        }
    }

    render() {
        let {guestbookMessages, getMemberGuestbook} = this.props,
            {isLoading, list, totalCount, offset} = guestbookMessages;

        const sizes = [
            { mq: '320px', columns: 1, gutter: 10 },
            { mq: '360px', columns: 1, gutter: 10 },
            { mq: '680px', columns: 2, gutter: 10 },
            { mq: '720px', columns: 2, gutter: 20 },
            { mq: '1060px', columns: 3, gutter: 20 },
            { mq: '1420px', columns: 4, gutter: 25 },
            { mq: '1560px', columns: 4, gutter: 30 },
            { mq: '1601px', columns: 4, gutter: 40 },
        ];

        return (
            <div id="wrapper">
                <HeaderMemberGuestbook />

                <div className="list-guestbook">
                    <div className="content">
                        <div className="heading">
                            <h2>{t('My guestbook')}<em>{totalCount}</em></h2>
                            <DisableMyGuestbook/>
                        </div>
                        <div className="lists">
                            <MasonryLayout
                                infiniteScroll={() => getMemberGuestbook(offset)}
                                infiniteScrollLoading={isLoading}
                                infiniteScrollEnd={offset >= totalCount}
                                infiniteScrollEndIndicator={null}
                                infiniteScrollSpinner={null}
                                sizes={sizes}
                                id="member-guestbook"
                                ref={(ref) => this.masonryLayout = ref}
                            >
                                {list.map((item) => <GuestbookItem key={item.id} guestbookMessage={item} deleteButton/>)}
                            </MasonryLayout>
                        </div>
                    </div>
                </div>

                <Footer />
            </div>
        )
    }
}

export default connect(
    state => ({
        guestbookMessages: state.memberGuestbook
    }),({
        getMemberGuestbook: getMemberGuestbook
    })
)(MemberGuestbook)


// WEBPACK FOOTER //
// ./src/containers/member/MemberGuestbook.js